//【PC用】メニュー（サイドメニュー項目）
$(function () {
  "use strict";
  $(".list_slider").css("display", "none");
  $(".list_slider_button").click(function () {
    $(this).next(".list_slider").slideToggle();
    return false;
  });
});

//【スマホ用】メニュー（スクロールすると追従）
$(function () {
  "use strict";
  spMenu();
  $(window).resize(function () {
    spMenu();
  });
});
function spMenu() {
  "use strict";
  var box = $("#menu_sp");
  var boxH = $("#menu_sp_icon").height();
  var boxTop = $("#header_menu").height();
  var props = {
    width: "100%",
    "background-color": "rgba(255,255,255,1.0)",
  };
  $(window).scroll(function () {
    if ($(window).scrollTop() >= boxTop) {
      box.addClass("fixed").css(props);
      $("body").css("margin-top", boxH);
    } else {
      box.removeClass("fixed").removeAttr("style");
      $("body").css("margin-top", 0);
    }
  });
}
//【スマホ用】メニュー（アイコンで該当の項目が出てくる）
$(function () {
  "use strict";
  var button = "#menu_sp_icon > li";
  var content = "#menu_sp_slider";
  var close_bt = "#menu_sp_close";
  $(content).children("div").css("display", "none");
  $(close_bt).css("display", "none");
  $(button).click(function () {
    var obj = $(this);
    var slider_button = obj.attr("slider_button");
    var point = $(content).children(
      "div[slider_content*=" + slider_button + "]"
    );
    obj.toggleClass("active");
    $(close_bt).slideDown();
    $(button).not(obj).removeClass("active");
    $(point).slideToggle();
    $(content).children("div").not(point).slideUp();
    return false;
  });
  $(close_bt).click(function () {
    $(content).slideUp();
  });
});


//共通/////////////////////////////////////////////////////////////
// PCとSPでの位置移動【バナー】
$(function () {
  "use strict";
  setSize();
  $(window).resize(function () {
    setSize();
  });
});
function setSize() {
  "use strict";
  var w = $(window).width();
  var x = 1024;
  if (w <= x) {
    $("#banner").prependTo("footer").removeClass("side_sub");
    $("#banner_feature").prependTo("footer").removeClass("side_sub");
  } else {
    $("#banner_feature").appendTo("#side nav").addClass("side_sub");
    $("#banner").appendTo("#side nav").addClass("side_sub");
  }
}



// 上に戻る
$(function () {
  "use strict";
  $("body").append('<div class="scrollTop"><span></span></div>');
  var scrollTop = $(".scrollTop");
  $(window).scroll(function () {
    var topPos = $(this).scrollTop();
    if (topPos > 100) {
      $(scrollTop).css("opacity", "1");
    } else {
      $(scrollTop).css("opacity", "0");
    }
  });
  $(scrollTop).click(function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      800
    );
    return false;
  });
});

//商品詳細での解説用タブ
$(function () {
  $("#tab-box div:first").addClass("active");
  $("#tab-menu li").on("click", function () {
    if ($(this).not("active")) {
      $(this).addClass("active").siblings("li").removeClass("active");
      var index = $("#tab-menu li").index(this);
      $("#tab-box div")
        .eq(index)
        .addClass("active")
        .siblings("div")
        .removeClass("active");
    }
  });
});


//送料無料テキスト表示・非表示
$(function ()  {
      setTimeout('func();', 10);
});

function func() {
    if ($("#AddToCartText").text() == 'SOLD OUT') {
      $("#shipping-text").hide();
    }
};
